require('../../js/theme');
require('./termos-de-uso.scss');
